export default "__VITE_ASSET__eMWXLhg6UGi$2gfyQGEgFQ__"